<template>
  <div>
    <router-view @closeMenu="$emit('closeMenu')"/>
  </div>
</template>

<script>
export default {
  name: 'Planning',
}
</script>